import { render } from "./message-product-card.vue?vue&type=template&id=9d0bbf2e&scoped=true&ts=true"
import script from "./message-product-card.vue?vue&type=script&lang=ts"
export * from "./message-product-card.vue?vue&type=script&lang=ts"

import "./message-product-card.vue?vue&type=style&index=0&id=9d0bbf2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0bbf2e"]])

export default __exports__